import { NextImage, TickSVG } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import { FC } from 'react'

const Container = styled(Box)`
  align-items: center;
  aspect-ratio: 1;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  width: 80px;
`

const Tick = styled(NextImage)`
  aspect-ratio: 1;
  width: 100%;
`

const ApeironTick: FC<Props> = props => {
  const { className } = props

  return (
    <Container className={className}>
      <Tick className='Custom-Tick' src={TickSVG} />
    </Container>
  )
}

type Props = {
  className?: string
}

export default ApeironTick
